import type { Config } from './ConfigType';

const apiEndpoint: string = 'https://api.socrates-conference.de';
const config: Config = {
  conference: 'socrates26',
  logoPath: 'https://socrates-conference.de',
  apiEndpoints: {
    attendees: apiEndpoint,
    applications: apiEndpoint,
    sponsors: apiEndpoint,
    conferences: apiEndpoint,
    applicants: apiEndpoint,
    subscriptions: apiEndpoint,
  },
  isRegistrationOpen: true,
};
export default config;
